(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[782],{

/***/ 74932:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies",
      function () {
        return __webpack_require__(34120);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41898);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68579);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90573);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25352);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81606);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46087);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _typeform_embed_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18865);
/* harmony import */ var _typeform_embed_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46496);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);





const SEO = {
    title: "Companies // Olby",
    description: "Engaging tech talent for trustworthy companies"
};
const Companies = ()=>{
    const sectionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const newsletterRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,_platform_website_components__WEBPACK_IMPORTED_MODULE_3__/* .useUpdateHeader */ .G)(sectionRef, _platform_website_components__WEBPACK_IMPORTED_MODULE_4__/* .HEADER_THEMES.NEUTRAL_BACKGROUND */ ._.NEUTRAL_BACKGROUND);
    (0,_platform_website_components__WEBPACK_IMPORTED_MODULE_3__/* .useUpdateHeader */ .G)(newsletterRef, _platform_website_components__WEBPACK_IMPORTED_MODULE_4__/* .HEADER_THEMES.EXT_DEEP_BLUE */ ._.EXT_DEEP_BLUE);
    (0,_platform_website_components__WEBPACK_IMPORTED_MODULE_5__/* .useCleanHeader */ ._)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
                ref: sectionRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_7__/* .WebsiteSeo */ .P, {
                        seo: SEO
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["content-wrapper"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                children: "Become a partner company"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
                                children: "Fill in your company information for us to contact you and engage best possible talent to work at your company."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typeform_embed_react__WEBPACK_IMPORTED_MODULE_2__.Widget, {
                                    id: "n5Ghm0QH",
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().typeform)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_8__/* .TalentNewsletterSections */ .w, {
                ref: newsletterRef
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Companies);
Companies.getLayout = (page)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_9__/* .WebsiteLayout */ .CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: _platform_website_components__WEBPACK_IMPORTED_MODULE_4__/* .HEADER_THEMES.NEUTRAL_BACKGROUND */ ._.NEUTRAL_BACKGROUND,
        children: page
    });
};


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 81606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ TalentNewsletterSections; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _newsletter_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45169);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86829);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);




const TalentNewsletterSections = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["section-wrapper"]),
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                    children: [
                        "Join our ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().highlight),
                            children: "newsletter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                    children: "International career content straight to your inbox"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_newsletter_forms__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().form)
                })
            ]
        })
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TalentNewsletterSections)));


/***/ }),

/***/ 46496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"companies_wrapper__1MQcy","content-wrapper":"companies_content-wrapper__2gWa6","title":"companies_title__kH3LU","theme--light":"companies_theme--light__hKP0o","theme--dark":"companies_theme--dark__jr7SC","description":"companies_description__ExRn5","content":"companies_content__GQ6n7","typeform":"companies_typeform__0Iyi6","fade-in-up":"companies_fade-in-up__LLrDQ","fade-in-opacity":"companies_fade-in-opacity__upBPS","fade-in-up-opacity":"companies_fade-in-up-opacity__7C2JO","fade-out-opacity":"companies_fade-out-opacity__ZXOsT","fade-out-left":"companies_fade-out-left__QrEm4"};

/***/ }),

/***/ 86829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"newsletter_section-wrapper__6Wcri","theme--light":"newsletter_theme--light__bDCNk","theme--dark":"newsletter_theme--dark__78dKy","content":"newsletter_content__JeUPp","title":"newsletter_title__XfOmS","highlight":"newsletter_highlight__s307c","description":"newsletter_description__7LvNe","form":"newsletter_form__qd8ZV","fade-in-up":"newsletter_fade-in-up__3PcUI","fade-in-opacity":"newsletter_fade-in-opacity__k8xlF","fade-in-up-opacity":"newsletter_fade-in-up-opacity__0BfOD","fade-out-opacity":"newsletter_fade-out-opacity__8ULql","fade-out-left":"newsletter_fade-out-left__4dfDv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,955,474,865,559,169,774,888,179], function() { return __webpack_exec__(74932); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);